export const ValidationMessages = {
  selectPrivacyAndTerm: 'Please review and accept the Privacy and Terms policies to finish creating your account.',
  passwordNotMatch: 'Passwords do not match, please correct.',
  passwordValidation: 'Passwords must be at least 8 characters long but no longer than 99 characters and contain at least one number and upper case letter. Passwords must not be an email address or first / last name of user.',
  repeatOldPassword: 'Password should not match last password used.',
  incorrectOldPassword: 'Old password value is incorrect. Please try again.',
  accountPasswordNotMatch: 'New password & confirmation does not match. Please try again.',
  resetFailed: 'This password reset request has expired. Press request a password reset to try again.',
  requiredFields: 'Please fill all required fields.',
  incorrectEmail: 'Please enter a valid email address',
  incorrectPhone: 'Phone number must contain 10 digits.'
}

export const SuccessMessage = {
  passwordChanged: 'Your password has been changed.',
  resetSuccessful: 'Check your email for a link to reset your password.',
  passwordSet: 'Thank you! Your account is now active. Use your email & password to sign in from now on'
}

export const NoDocumentsFoundMessage = {
  message: 'No documents are available to display.',
  linkText: ''
};

export const NoDocumentSearchResultsFoundMessage = (query: string) => ({
  message: `No documents were found matching '${query}.' `,
  linkText: 'View all documents'
});

export const UploadMessage = (uploadOption: string, uploadMode: string) => ({
  uploadMessage: `"Drees Homes" Would Like To Access The ${uploadOption}`,
  uploadDesc: `This will let you ${uploadMode}`,
  failMessage: `${uploadOption} Access Denied`,
  failDesc: `Kindly grant permission to the ${uploadOption} from the mobile settings.`
});
